(ns hai.ui.components.pill
  #?(:cljs (:require-macros hai.ui.components.pill))
  (:require
   [lambdaisland.ornament :as o]
   [hai.ui.tokens :as t]))

(o/defstyled pill :div
  {:background-color t/--bg-2
   :padding "4px 12px"
   :border-radius "9999px"
   :display "inline-flex"
   :align-items "center"}
  ([]
   [:<> [:span "Customer support"]]))

(o/defstyled removable-pill :div
  :flex :items-center
  {:gap "0.5rem"
   :padding "0.1875rem 0.5rem"
   :border (str "1px solid " t/--text-secondary-30)
   :color t/--text-secondary
   :border-radius "0.25rem"
   :background-color t/--bg-1
   :cursor "pointer"})

(o/defstyled pill-close :span
  {:font-size "1rem"
   :color t/--text-secondary-50}
  ([props]
   [:<> props "✕"]))

